import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "./context/AuthContext";
import AuthPage from "./pages/Freight/Common/AuthPage";
import Dashboard from "./pages/Freight/Common/Dashboard";
import CreateEnquiry from "./pages/Freight/Client/Enquiry/CreateEnquiry";
import ViewEnquiry from "./pages/Freight/Client/Enquiry/ViewEnquiry";
import ViewEnquiryDetails from "./pages/Freight/Client/Enquiry/ViewEnquiryDetails";
import EditEnquiry from "./pages/Freight/Client/Enquiry/EditEnquiry";
import ErrorBoundary from "./components/ErrorBoundary";
import Layout from "./pages/Freight/Common/Layout";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import ProtectedRoute from "./components/ProtectedRoute";
import PendingEnquiries from "./pages/Freight/Admin/Enquiry/PendingEnquiries";
import ForgotPassword from "./pages/Freight/Common/ForgotPassword";
import SendQuotation from "./pages/Freight/Admin/Quotation/SendQuotation";
import ViewQuotation from "./pages/Freight/Client/Enquiry/ViewQuotation";
import UserProfile from "./pages/Freight/Client/Profile/UserProfile";
import Ports from "./pages/Freight/Admin/MasterData/Ports";
import ViewBookings from "./pages/Freight/Client/Booking/ViewBookings";
import ListofBookings from "./pages/Freight/Client/Booking/ListofBookings";
import CreateSI from "./pages/Freight/Client/SI/CreateSI";
import UploadDocuments from "./pages/Freight/Client/Profile/UploadDocuments";
import ListofBookingsAdmin from "./pages/Freight/Admin/Booking/ListofBookingsAdmin";
import ViewBookingAdmin from "./pages/Freight/Admin/Booking/ViewBookingAdmin";
import EditBookingAdmin from "./pages/Freight/Admin/Booking/EditBookingAdmin";
import ListofBL from "./pages/Freight/Client/BL/ListofBL";
import ListofBLAdmin from "./pages/Freight/Admin/BL/ListofBLAdmin";
import ViewSIAdmin from "./pages/Freight/Admin/SI/ViewSIAdmin";
import ViewBLdraft from "./pages/Freight/Client/BL/ViewBLdraft";
import CreateSIAdmin from "./pages/Freight/Admin/SI/CreateSIAdmin";
import ExchangeRate from "./pages/Freight/Admin/MasterData/ExchangeRate";
import ChargeCode from "./pages/Freight/Admin/MasterData/ChargeCode";
import VendorMaster from "./pages/Freight/Admin/MasterData/VendorMaster";
import ContainerStatus from "./pages/Freight/Admin/MasterData/JobMaster.js";
// import ContainerStatus from "./pages/Freight/Admin/MasterData/ContainerStatus";
import ClientMaster from "./pages/Freight/Admin/MasterData/ClientMaster";
import UserMaster from "./pages/Freight/Admin/MasterData/UserMaster";
import ViewBookingDocument from "./pages/Freight/Admin/VerificationRequests/ViewBookingDocument";
import EditContainerStatusReport from "./pages/Freight/Admin/MasterData/EditContainerStatusReport";
import TermsAndConditions from "./pages/Freight/Admin/MasterData/TermsAndCondtions";
import ListOfUnverifiedUsers from "./pages/Freight/Admin/VerificationRequests/ListOfUnverifiedUsers";
import ListOfGSTUpdateRequests from "./pages/Freight/Admin/VerificationRequests/ListOfGSTUpdateRequests";
import ListOfUploadedDocuments from "./pages/Freight/Admin/VerificationRequests/ListOfUploadedDocuments";
import ResetPassword from "./pages/Freight/Common/ResetPassword";
import EditShippingInstructions from "./pages/Freight/Client/SI/EditShippingInstructions";
import FreightEnquiries from "./pages/Sales/Sales_rep/FreightEnquiries";
import CreateEnquirySales from "./pages/Sales/Sales_rep/CreateEnquirySales";
import SalesDashboard from "./pages/Sales/Admin/SalesDashboard";
import SalesClients from "./pages/Sales/Admin/SalesClients";
import SalesEnquiries from "./pages/Sales/Admin/SalesEnquiries";
import SalesBooking from "./pages/Sales/Admin/SalesBooking";
import SpecialEnquiries from "./pages/Sales/Admin/SpecialEnquiries";
import HighVolumeCustomers from "./pages/Sales/Admin/HighVolumeCustomers";
import TotalFollowups from "./pages/Sales/Admin/TotalFollowups";
import ViewFollowupDetails from "./pages/Sales/Admin/ViewFollowupDetails";
import SalesViewEnquiry from "./pages/Sales/Admin/SalesViewEnquiry";
import WhRequestList from "./pages/ListofWhRequest";
import CreateWhRequest from "./pages/CreateWhRequest";
import WhRequestResponses from "./pages/WhRequestResponses";
import ConfirmWarehouse from "./pages/ConfirmWarehouse";
import AllNotifications from "./pages/Freight/Common/AllNotifications";
import WarehouseRequestsOwner from "./pages/WhRequestOwner";
import ViewWhRequest from "./pages/ViewWhRequest";
import ListWhAdmin from "./pages/ListWhAdmin";
import UserDocuments from "./pages/Freight/Admin/VerificationRequests/UserDocuments";
import WarehouseBookings from "./pages/WarehouseBookings";
import MyWarehouses from "./pages/MyWarehouses";
import CreateWarehouse from "./pages/CreateWarehouse";
import EditWarehouseRequests from "./pages/EditWhRequests.js";
import WarehouseAddRequests from "./pages/WarehouseAddRequests";
import ViewWarehouseDetails from "./pages/ViewWarehouseDetails";
import ChaServicesRequests from "./pages/ChaServicesRequests";
import ChaRequests from "./pages/ChaRequests";
import AuditDetails from "./pages/AuditDetails";
import ListofTransactions from "./pages/Billing&Invoice/Invoicing/ListofTransactions";
import PurchaseForm from "./pages/Billing&Invoice/Invoicing/PurchaseForm";
import InvoicingForm from "./pages/Billing&Invoice/Invoicing/Taxinvoice..js";
import Intelligence from "./pages/Freight/Common/Intelligence";
import MyProfile from "./pages/Freight/Admin/Profile/MyProfile";
import SessionExpiredModal from "./components/SessionExpiredModal";
import InactivityWarningModal from "./components/InactivityWarningModal";
import { useInactivity } from "./context/InactivityContext";
import Operations from "./pages/Freight/Admin/MasterData/Operations";
import Commercial from "./pages/Freight/Admin/MasterData/Commercial";
import Documents from "./pages/Freight/Admin/MasterData/Documents";

const App = () => {
  const { user } = useAuth() || {};
  const { showWarning } = useInactivity() || {};
  const [showSessionExpiredModal, setShowSessionExpiredModal] = useState(false);

  // Hide modal when user is not logged in (on login page)
  useEffect(() => {
    if (!user) {
      setShowSessionExpiredModal(false);
    }
  }, [user]);

  // Listen for session expired event from api.js
  useEffect(() => {
    const handleSessionExpired = () => {
      // Only show modal if user is logged in
      const token = localStorage.getItem("token");
      if (token) {
        setShowSessionExpiredModal(true);
      }
    };

    const handleCloseModal = () => {
      setShowSessionExpiredModal(false);
    };

    window.addEventListener("sessionExpired", handleSessionExpired);
    window.addEventListener("closeSessionExpiredModal", handleCloseModal);

    // Cleanup
    return () => {
      window.removeEventListener("sessionExpired", handleSessionExpired);
      window.removeEventListener("closeSessionExpiredModal", handleCloseModal);
    };
  }, []);

  // Check for session expired flag on mount and when user changes
  useEffect(() => {
    const checkSessionExpired = () => {
      const showModal = localStorage.getItem("showSessionExpiredModal");
      if (showModal === "true") {
        setShowSessionExpiredModal(true);
        // Clear the flag
        localStorage.removeItem("showSessionExpiredModal");
      }
    };

    // Check immediately
    checkSessionExpired();

    // Also check when user changes (after login)
    if (user) {
      checkSessionExpired();
    }
  }, [user]);

  const handleCloseSessionExpiredModal = () => {
    setShowSessionExpiredModal(false);
  };

  return (
    <ErrorBoundary>
      <Router>
        {showSessionExpiredModal && (
          <SessionExpiredModal />
        )}
        {!showSessionExpiredModal && showWarning && user && (
          <InactivityWarningModal />
        )}
        <Routes>
          <Route path="/login" element={<AuthPage />} />
          <Route path="/signup" element={<AuthPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* {!user && (
            <Route path="*" element={<Navigate to="/login" replace />} />
          )} */}
          <Route
            path="*"
            element={<Navigate to={user ? "/" : "/login"} replace />}
          />

          {!user && (
            <>
              <Route path="/login" element={<AuthPage />} />
              <Route path="/signup" element={<AuthPage />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
            </>
          )}
          {/* Protected Routes */}
          {user && (
            <Route path="/" element={<ProtectedRoute element={<Layout />} />}>
              <Route index element={<Dashboard />} />
              <Route
                path={
                  user?.user_role === "SuperAdmin" ||
                  user?.user_role === "Admin" ||
                  user?.user_role === "sales_rep"
                    ? "/create-enquiry"
                    : "/my-enquiry/create-enquiry"
                }
                element={<CreateEnquiry />}
              />
              {
                /* <Route path="/extra" element={<Extra />} />*/
                <Route
                  path="/my-enquiry/view-enquiry"
                  element={<ViewEnquiry />}
                />
              }
              <Route
                path="/my-enquiry/view-enquiry-details/:id"
                element={<ViewEnquiryDetails />}
              />
              <Route
                path="/my-enquiry/edit-enquiry"
                element={<EditEnquiry />}
              />
              <Route
                path="/my-enquiry/edit-enquiry/:id"
                element={<EditEnquiry />}
              />
              <Route
                path="/freight/pending-enquiries"
                element={<PendingEnquiries />}
              />
              <Route path="/freight-enquiries" element={<FreightEnquiries />} />
              <Route
                path="/freight/view-booking/admin"
                element={<ListofBookingsAdmin />}
              />
              <Route path="/send-quotation/:id" element={<SendQuotation />} />
              <Route path="/view-quotation/:id" element={<ViewQuotation />} />
              <Route
                path="/my-bookings/view-bookings/admin/:id"
                element={<ViewBookingAdmin />}
              />
              <Route
                path="/my-bookings/edit-bookings/admin/:id"
                element={<EditBookingAdmin />}
              />
              <Route path="/user-profile" element={<UserProfile />} />
               <Route path="/my-profile" element={<MyProfile />} />

              <Route path="/warehouse-requests-owner" element={<WarehouseRequestsOwner />} />
              <Route path="/my-warehouses" element={<MyWarehouses />} />
              <Route path="/create-warehouse" element={<CreateWarehouse />} />
              <Route path="/warehouse-add-requests" element={<WarehouseAddRequests />} />
              <Route path="/view-warehouse-details/:id" element={<ViewWarehouseDetails />} />
              <Route
                path="/my-bookings/list-of-bookings"
                element={<ListofBookings />}
              />
              <Route
                path="/my-bookings/view-bookings/:id"
                element={<ViewBookings />}
              />
              <Route
                path="/my-bookings/create-shipping-instructions/:id"
                element={<CreateSI />}
              />
              <Route
                path="/my-bookings/upload-document/:id"
                element={<UploadDocuments />}
              />
              <Route path="/my-bookings/list-of-bl" element={<ListofBL />} />
              <Route path="/list-of-bl/admin" element={<ListofBLAdmin />} />
              <Route path="/view-si/admin/:id" element={<ViewSIAdmin />} />
              <Route path="/create-si/admin/:id" element={<CreateSIAdmin />} />
              <Route path="/view-bl-draft/:id" element={<ViewBLdraft />} />
              <Route
                path="/upload-documents/:id"
                element={<UploadDocuments />}
              />
              <Route
                path="/create-enquiry-sales/:id"
                element={<CreateEnquirySales />}
              />

              <Route
                path="/master-data/exchange-rate"
                element={<ExchangeRate />}
              />
              <Route
                path="/master-data/charge-code"
                element={<ChargeCode />}
              />
              <Route
                path="/master-data/vendor-master"
                element={<VendorMaster />}
              />
              <Route
                path="/master-data/job-master"
                element={<ContainerStatus />}
              />
              <Route
                path="/view-booking-documents/:enq_id"
                element={<ViewBookingDocument />}
              />
              <Route
                path="/edit-container-status/:id"
                element={<EditContainerStatusReport />}
              />
              <Route
                path="/master-data/client-master"
                element={<ClientMaster />}
              />

              <Route path="/operations/:id" element={<Operations />} />
              <Route path="/commercial/:id" element={<Commercial />} />
               <Route path="/documents/:id" element={<Documents />} /> 
              <Route
                path="/master-data/ports"
                element={<Ports />}
              />
              <Route path="/master-data/user-master" element={<UserMaster />} />
              <Route
                path="/master-data/terms-and-conditions"
                element={<TermsAndConditions />}
              />

              <Route
                path="/unverified-users"
                element={<ListOfUnverifiedUsers />}
              />
              <Route
                path="/gst-update-requests"
                element={<ListOfGSTUpdateRequests />}
              />
              <Route
                path="/admin/user/:userId/documents"
                element={<ListOfUploadedDocuments />}
              />

              <Route
                path="/my-bookings/edit-shipping-instructions/:id"
                element={<EditShippingInstructions />}
              />

              <Route path="/warehouse-Requests" element={<WhRequestList />} />
              <Route
                path="/create-warehouses-request"
                element={<CreateWhRequest />}
              />
              <Route
                path="/warehouse-request-responses/:id"
                element={<WhRequestResponses />}
              />
              <Route
                path="/confirm-warehouse/:id/:warehouseId/:ownerId"
                element={<ConfirmWarehouse />}
              />
              <Route path="/view-wh-request/:request_id/:warehouse_id" element={<ViewWhRequest />} />
              <Route path="/list-wh-admin" element={<ListWhAdmin />} />
              <Route path="/warehouse-bookings" element={<WarehouseBookings />} />
              <Route path="/user-documents/:id" element={<UserDocuments />} />
              <Route path="/edit-warehouse-requests/:id" element={<EditWarehouseRequests />}/>
              {/*Sales Routes*/}

              <Route path="/sales-dashboard" element={<SalesDashboard />} />
              <Route path="/intelligence" element={<Intelligence />} />
              <Route path="/sales-clients" element={<SalesClients />} />
              <Route path="/sales-enquiries" element={<SalesEnquiries />} />
              <Route path="/sales-bookings" element={<SalesBooking />} />
              <Route path="/special-enquiries" element={<SpecialEnquiries />} />
              <Route path="/high-volume-customers" element={<HighVolumeCustomers />} />
              <Route path="/total-followups" element={<TotalFollowups />} />
              <Route path="/view-followup-details/:id" element={<ViewFollowupDetails />} />
              <Route path="/all-notifications" element={<AllNotifications />} />
              <Route
                path="/sales-view-enquiry/:id"
                element={<SalesViewEnquiry />}
              />

              {/*Sales Routes*/}

              <Route path="/cha-services-requests" element={<ChaServicesRequests />} />
              <Route path="/cha-requests" element={<ChaRequests />} />
              <Route path="/audit-details/:id" element={<AuditDetails />} />
              <Route
                path="/billingAndInvoice/invoicing"
                element={<ListofTransactions />}
              />
              <Route
                path="/purchase-details/:id"
                element={<PurchaseForm />}
              />
              <Route
                path="/invoice-details/:id/:enq_id"
                element={<InvoicingForm />}
              />

            </Route>
          )}
        </Routes>
      </Router>
    </ErrorBoundary>
  );
};
export default App;
